<ng-container *ngIf="item">
  <div class="w-full">
    <ui-paragraph
      type="p10"
      mobile-type="p10"
      text-color="neutrals-700"
      font-weight="semibold"
      [content]="fromName"
      *ngIf="hasFromName"
    />
  </div>
  <div class="w-full grid grid-flow-col gap-1 items-start justify-start">
    <ui-icon
      *ngIf="buttonLinkResponse"
      name="clock-filled"
      fill="primary-500"
      m-size="16"
      size="16"
    />
    <p
      class="m-0 p-0 message-text whitespace-pre-line"
      [ngClass]="{
        'button-link-response text-primary-500': buttonLinkResponse,
        'text-neutrals-900': !buttonLinkResponse,
      }"
      [innerHTML]="formatText(item.content.value ? item.content.value : '')"
    ></p>
  </div>
  <div class="w-full flex justify-end">
    <ui-paragraph
      type="p8"
      mobile-type="p8"
      text-color="neutrals-600"
      font-weight="regular"
      [content]="item.createdDateTime | date: 'hh:mm a'"
    />
  </div>
</ng-container>
